export const ignoreErrorsEndpoints = [''];
